import { ExtendedQuestionnaireBlock } from '../components/compliance/ExtendedQuestionnaire';

// Additional NIS2 Full categories (5-12) to complete the 135-question questionnaire
// Categories 1-4 are already in nis2FullQuestionnairesComplete.ts

export const NIS2_FULL_CATEGORIES_5_12: ExtendedQuestionnaireBlock[] = [
  // Category 5: Supply Chain Security (11 questions)
  {
    id: 'nis2-supply-chain-security',
    name_en: 'Supply Chain Security',
    name_es: 'Seguridad de la Cadena de Suministro',
    name_ru: 'Безопасность цепочки поставок',
    questions: [
      {
        id: 'NIS2_SCS_01',
        blockId: 'nis2-supply-chain-security',
        text_en: 'Are supplier risks assessed and documented?',
        text_es: '¿Los riesgos de proveedores se evalúan y documentan?',
        text_ru: 'Оцениваются и документируются ли риски поставщиков?',
        weight: 5,
      },
      {
        id: 'NIS2_SCS_02',
        blockId: 'nis2-supply-chain-security',
        text_en: 'Are security requirements included in supplier contracts?',
        text_es: '¿Los requisitos de seguridad se incluyen en los contratos de proveedores?',
        text_ru: 'Включены ли требования безопасности в контракты с поставщиками?',
        weight: 5,
      },
      {
        id: 'NIS2_SCS_03',
        blockId: 'nis2-supply-chain-security',
        text_en: 'Do you maintain a supplier security assessment process?',
        text_es: '¿Mantiene un proceso de evaluación de seguridad de proveedores?',
        text_ru: 'Ведется ли процесс оценки безопасности поставщиков?',
        weight: 4,
      },
      {
        id: 'NIS2_SCS_04',
        blockId: 'nis2-supply-chain-security',
        text_en: 'Are critical suppliers subject to enhanced due diligence?',
        text_es: '¿Los proveedores críticos están sujetos a una diligencia debida mejorada?',
        text_ru: 'Подвергаются ли критичные поставщики расширенной проверке?',
        weight: 4,
      },
      {
        id: 'NIS2_SCS_05',
        blockId: 'nis2-supply-chain-security',
        text_en: 'Is supplier compliance monitored continuously?',
        text_es: '¿El cumplimiento de los proveedores se monitorea continuamente?',
        text_ru: 'Постоянно ли отслеживается соответствие поставщиков?',
        weight: 3,
      },
      {
        id: 'NIS2_SCS_06',
        blockId: 'nis2-supply-chain-security',
        text_en: 'Do you have incident notification requirements for suppliers?',
        text_es: '¿Tiene requisitos de notificación de incidentes para proveedores?',
        text_ru: 'Есть ли требования к уведомлению об инцидентах для поставщиков?',
        weight: 4,
      },
      {
        id: 'NIS2_SCS_07',
        blockId: 'nis2-supply-chain-security',
        text_en: 'Are supplier access rights reviewed regularly?',
        text_es: '¿Los derechos de acceso de proveedores se revisan regularmente?',
        text_ru: 'Регулярно ли пересматриваются права доступа поставщиков?',
        weight: 3,
      },
      {
        id: 'NIS2_SCS_08',
        blockId: 'nis2-supply-chain-security',
        text_en: 'Is there a process for supplier offboarding?',
        text_es: '¿Existe un proceso para la desvinculación de proveedores?',
        text_ru: 'Существует ли процесс отключения поставщиков?',
        weight: 3,
      },
      {
        id: 'NIS2_SCS_09',
        blockId: 'nis2-supply-chain-security',
        text_en: 'Are supplier dependencies mapped and assessed?',
        text_es: '¿Las dependencias de proveedores se mapean y evalúan?',
        text_ru: 'Отображаются и оцениваются ли зависимости от поставщиков?',
        weight: 4,
      },
      {
        id: 'NIS2_SCS_10',
        blockId: 'nis2-supply-chain-security',
        text_en: 'Do you track supplier security certifications?',
        text_es: '¿Rastrea las certificaciones de seguridad de proveedores?',
        text_ru: 'Отслеживаете ли вы сертификаты безопасности поставщиков?',
        weight: 2,
      },
      {
        id: 'NIS2_SCS_11',
        blockId: 'nis2-supply-chain-security',
        text_en: 'Is supplier security integrated into procurement processes?',
        text_es: '¿La seguridad de proveedores está integrada en los procesos de adquisición?',
        text_ru: 'Интегрирована ли безопасность поставщиков в процессы закупок?',
        weight: 4,
      },
    ],
  },
  // Category 6: Network Security (12 questions)
  {
    id: 'nis2-network-security',
    name_en: 'Network Security',
    name_es: 'Seguridad de Red',
    name_ru: 'Сетевая безопасность',
    questions: [
      {
        id: 'NIS2_NS_01',
        blockId: 'nis2-network-security',
        text_en: 'Is network segmentation implemented?',
        text_es: '¿Se implementa la segmentación de red?',
        text_ru: 'Реализована ли сегментация сети?',
        weight: 5,
      },
      {
        id: 'NIS2_NS_02',
        blockId: 'nis2-network-security',
        text_en: 'Are firewalls configured and maintained?',
        text_es: '¿Los firewalls están configurados y mantenidos?',
        text_ru: 'Настроены и поддерживаются ли файрволы?',
        weight: 4,
      },
      {
        id: 'NIS2_NS_03',
        blockId: 'nis2-network-security',
        text_en: 'Is network traffic monitored continuously?',
        text_es: '¿El tráfico de red se monitorea continuamente?',
        text_ru: 'Постоянно ли отслеживается сетевой трафик?',
        weight: 4,
      },
      {
        id: 'NIS2_NS_04',
        blockId: 'nis2-network-security',
        text_en: 'Are intrusion detection/prevention systems deployed?',
        text_es: '¿Se despliegan sistemas de detección/prevención de intrusiones?',
        text_ru: 'Развернуты ли системы обнаружения/предотвращения вторжений?',
        weight: 5,
      },
      {
        id: 'NIS2_NS_05',
        blockId: 'nis2-network-security',
        text_en: 'Are wireless networks secured and isolated?',
        text_es: '¿Las redes inalámbricas están aseguradas y aisladas?',
        text_ru: 'Защищены и изолированы ли беспроводные сети?',
        weight: 4,
      },
      {
        id: 'NIS2_NS_06',
        blockId: 'nis2-network-security',
        text_en: 'Is VPN access secured and monitored?',
        text_es: '¿El acceso VPN está asegurado y monitoreado?',
        text_ru: 'Защищен и отслеживается ли VPN доступ?',
        weight: 4,
      },
      {
        id: 'NIS2_NS_07',
        blockId: 'nis2-network-security',
        text_en: 'Are network access controls enforced?',
        text_es: '¿Se hacen cumplir los controles de acceso a la red?',
        text_ru: 'Обеспечивается ли соблюдение контроля доступа к сети?',
        weight: 4,
      },
      {
        id: 'NIS2_NS_08',
        blockId: 'nis2-network-security',
        text_en: 'Is DNS security implemented?',
        text_es: '¿Se implementa la seguridad DNS?',
        text_ru: 'Реализована ли безопасность DNS?',
        weight: 3,
      },
      {
        id: 'NIS2_NS_09',
        blockId: 'nis2-network-security',
        text_en: 'Are network devices hardened and patched?',
        text_es: '¿Los dispositivos de red están endurecidos y parcheados?',
        text_ru: 'Усилены и пропатчены ли сетевые устройства?',
        weight: 4,
      },
      {
        id: 'NIS2_NS_10',
        blockId: 'nis2-network-security',
        text_en: 'Is network architecture documented and reviewed?',
        text_es: '¿La arquitectura de red está documentada y revisada?',
        text_ru: 'Документирована и пересматривается ли архитектура сети?',
        weight: 3,
      },
      {
        id: 'NIS2_NS_11',
        blockId: 'nis2-network-security',
        text_en: 'Are network security incidents logged and analyzed?',
        text_es: '¿Los incidentes de seguridad de red se registran y analizan?',
        text_ru: 'Регистрируются и анализируются ли сетевые инциденты безопасности?',
        weight: 3,
      },
      {
        id: 'NIS2_NS_12',
        blockId: 'nis2-network-security',
        text_en: 'Is network security tested periodically?',
        text_es: '¿La seguridad de red se prueba periódicamente?',
        text_ru: 'Периодически ли тестируется сетевая безопасность?',
        weight: 4,
      },
    ],
  },
  // Category 7: Access Control (13 questions)
  {
    id: 'nis2-access-control',
    name_en: 'Access Control',
    name_es: 'Control de Acceso',
    name_ru: 'Контроль доступа',
    questions: [
      {
        id: 'NIS2_AC_01',
        blockId: 'nis2-access-control',
        text_en: 'Is the principle of least privilege implemented?',
        text_es: '¿Se implementa el principio de menor privilegio?',
        text_ru: 'Реализован ли принцип наименьших привилегий?',
        weight: 5,
      },
      {
        id: 'NIS2_AC_02',
        blockId: 'nis2-access-control',
        text_en: 'Is multi-factor authentication (MFA) enforced for critical systems?',
        text_es: '¿La autenticación multifactor (MFA) se aplica para sistemas críticos?',
        text_ru: 'Требуется ли многофакторная аутентификация (MFA) для критических систем?',
        weight: 5,
      },
      {
        id: 'NIS2_AC_03',
        blockId: 'nis2-access-control',
        text_en: 'Is user access reviewed and recertified regularly?',
        text_es: '¿El acceso de usuarios se revisa y recertifica regularmente?',
        text_ru: 'Регулярно ли пересматривается и пересертифицируется доступ пользователей?',
        weight: 4,
      },
      {
        id: 'NIS2_AC_04',
        blockId: 'nis2-access-control',
        text_en: 'Is privileged access managed and monitored?',
        text_es: '¿El acceso privilegiado se gestiona y monitorea?',
        text_ru: 'Управляется и отслеживается ли привилегированный доступ?',
        weight: 5,
      },
      {
        id: 'NIS2_AC_05',
        blockId: 'nis2-access-control',
        text_en: 'Are access rights revoked upon termination?',
        text_es: '¿Los derechos de acceso se revocan al terminar?',
        text_ru: 'Отзываются ли права доступа при увольнении?',
        weight: 4,
      },
      {
        id: 'NIS2_AC_06',
        blockId: 'nis2-access-control',
        text_en: 'Is role-based access control (RBAC) implemented?',
        text_es: '¿Se implementa el control de acceso basado en roles (RBAC)?',
        text_ru: 'Реализован ли контроль доступа на основе ролей (RBAC)?',
        weight: 4,
      },
      {
        id: 'NIS2_AC_07',
        blockId: 'nis2-access-control',
        text_en: 'Is password policy enforced and compliant?',
        text_es: '¿La política de contraseñas se aplica y cumple?',
        text_ru: 'Обеспечивается ли соблюдение политики паролей?',
        weight: 3,
      },
      {
        id: 'NIS2_AC_08',
        blockId: 'nis2-access-control',
        text_en: 'Is account lockout configured after failed attempts?',
        text_es: '¿El bloqueo de cuenta se configura después de intentos fallidos?',
        text_ru: 'Настроена ли блокировка учетной записи после неудачных попыток?',
        weight: 3,
      },
      {
        id: 'NIS2_AC_09',
        blockId: 'nis2-access-control',
        text_en: 'Are shared accounts restricted and monitored?',
        text_es: '¿Las cuentas compartidas están restringidas y monitoreadas?',
        text_ru: 'Ограничены и отслеживаются ли общие учетные записи?',
        weight: 4,
      },
      {
        id: 'NIS2_AC_10',
        blockId: 'nis2-access-control',
        text_en: 'Is single sign-on (SSO) implemented where appropriate?',
        text_es: '¿El inicio de sesión único (SSO) se implementa donde sea apropiado?',
        text_ru: 'Реализован ли единый вход (SSO) где это уместно?',
        weight: 3,
      },
      {
        id: 'NIS2_AC_11',
        blockId: 'nis2-access-control',
        text_en: 'Is access to sensitive data logged and audited?',
        text_es: '¿El acceso a datos sensibles se registra y audita?',
        text_ru: 'Регистрируется и аудируется ли доступ к чувствительным данным?',
        weight: 4,
      },
      {
        id: 'NIS2_AC_12',
        blockId: 'nis2-access-control',
        text_en: 'Is segregation of duties enforced?',
        text_es: '¿Se aplica la segregación de funciones?',
        text_ru: 'Обеспечивается ли разделение обязанностей?',
        weight: 4,
      },
      {
        id: 'NIS2_AC_13',
        blockId: 'nis2-access-control',
        text_en: 'Are access control exceptions documented and approved?',
        text_es: '¿Las excepciones de control de acceso están documentadas y aprobadas?',
        text_ru: 'Документированы и утверждены ли исключения контроля доступа?',
        weight: 3,
      },
    ],
  },
  // Category 8: Incident Response (12 questions)
  {
    id: 'nis2-incident-response',
    name_en: 'Incident Response',
    name_es: 'Respuesta a Incidentes',
    name_ru: 'Реагирование на инциденты',
    questions: [
      {
        id: 'NIS2_IR_01',
        blockId: 'nis2-incident-response',
        text_en: 'Is an incident response plan documented and approved?',
        text_es: '¿Un plan de respuesta a incidentes está documentado y aprobado?',
        text_ru: 'Документирован и утвержден ли план реагирования на инциденты?',
        weight: 5,
      },
      {
        id: 'NIS2_IR_02',
        blockId: 'nis2-incident-response',
        text_en: 'Is an incident response team designated and trained?',
        text_es: '¿Un equipo de respuesta a incidentes está designado y capacitado?',
        text_ru: 'Назначена и обучена ли команда реагирования на инциденты?',
        weight: 5,
      },
      {
        id: 'NIS2_IR_03',
        blockId: 'nis2-incident-response',
        text_en: 'Are incident detection capabilities in place?',
        text_es: '¿Las capacidades de detección de incidentes están en su lugar?',
        text_ru: 'Существуют ли возможности обнаружения инцидентов?',
        weight: 4,
      },
      {
        id: 'NIS2_IR_04',
        blockId: 'nis2-incident-response',
        text_en: 'Are incidents classified by severity and impact?',
        text_es: '¿Los incidentes se clasifican por severidad e impacto?',
        text_ru: 'Классифицируются ли инциденты по серьезности и воздействию?',
        weight: 4,
      },
      {
        id: 'NIS2_IR_05',
        blockId: 'nis2-incident-response',
        text_en: 'Is there a process for incident containment?',
        text_es: '¿Existe un proceso para la contención de incidentes?',
        text_ru: 'Существует ли процесс локализации инцидентов?',
        weight: 5,
      },
      {
        id: 'NIS2_IR_06',
        blockId: 'nis2-incident-response',
        text_en: 'Are incidents reported to competent authorities as required?',
        text_es: '¿Los incidentes se reportan a las autoridades competentes según se requiera?',
        text_ru: 'Сообщаются ли инциденты компетентным органам в соответствии с требованиями?',
        weight: 5,
      },
      {
        id: 'NIS2_IR_07',
        blockId: 'nis2-incident-response',
        text_en: 'Is post-incident analysis conducted?',
        text_es: '¿Se realiza un análisis post-incidente?',
        text_ru: 'Проводится ли анализ после инцидента?',
        weight: 4,
      },
      {
        id: 'NIS2_IR_08',
        blockId: 'nis2-incident-response',
        text_en: 'Are incident response procedures tested regularly?',
        text_es: '¿Los procedimientos de respuesta a incidentes se prueban regularmente?',
        text_ru: 'Регулярно ли тестируются процедуры реагирования на инциденты?',
        weight: 4,
      },
      {
        id: 'NIS2_IR_09',
        blockId: 'nis2-incident-response',
        text_en: 'Are incident records maintained and analyzed?',
        text_es: '¿Los registros de incidentes se mantienen y analizan?',
        text_ru: 'Ведется ли и анализируется ли учет инцидентов?',
        weight: 3,
      },
      {
        id: 'NIS2_IR_10',
        blockId: 'nis2-incident-response',
        text_en: 'Is communication with stakeholders managed during incidents?',
        text_es: '¿La comunicación con las partes interesadas se gestiona durante los incidentes?',
        text_ru: 'Управляется ли коммуникация с заинтересованными сторонами во время инцидентов?',
        weight: 3,
      },
      {
        id: 'NIS2_IR_11',
        blockId: 'nis2-incident-response',
        text_en: 'Is there coordination with external incident response providers?',
        text_es: '¿Existe coordinación con proveedores externos de respuesta a incidentes?',
        text_ru: 'Существует ли координация с внешними поставщиками услуг реагирования на инциденты?',
        weight: 3,
      },
      {
        id: 'NIS2_IR_12',
        blockId: 'nis2-incident-response',
        text_en: 'Are lessons learned from incidents incorporated into improvements?',
        text_es: '¿Las lecciones aprendidas de incidentes se incorporan en mejoras?',
        text_ru: 'Включаются ли уроки, извлеченные из инцидентов, в улучшения?',
        weight: 3,
      },
    ],
  },
  // Category 9: Monitoring & Logging (11 questions)
  {
    id: 'nis2-monitoring-logging',
    name_en: 'Monitoring & Logging',
    name_es: 'Monitoreo y Registro',
    name_ru: 'Мониторинг и логирование',
    questions: [
      {
        id: 'NIS2_ML_01',
        blockId: 'nis2-monitoring-logging',
        text_en: 'Is comprehensive logging enabled across critical systems?',
        text_es: '¿El registro integral está habilitado en sistemas críticos?',
        text_ru: 'Включено ли комплексное логирование на критических системах?',
        weight: 5,
      },
      {
        id: 'NIS2_ML_02',
        blockId: 'nis2-monitoring-logging',
        text_en: 'Are logs centrally collected and stored?',
        text_es: '¿Los registros se recopilan y almacenan centralmente?',
        text_ru: 'Собираются ли логи централизованно и хранятся?',
        weight: 4,
      },
      {
        id: 'NIS2_ML_03',
        blockId: 'nis2-monitoring-logging',
        text_en: 'Is log integrity protected?',
        text_es: '¿La integridad de los registros está protegida?',
        text_ru: 'Защищена ли целостность логов?',
        weight: 4,
      },
      {
        id: 'NIS2_ML_04',
        blockId: 'nis2-monitoring-logging',
        text_en: 'Are logs retained for the required period?',
        text_es: '¿Los registros se retienen por el período requerido?',
        text_ru: 'Хранятся ли логи в течение требуемого периода?',
        weight: 3,
      },
      {
        id: 'NIS2_ML_05',
        blockId: 'nis2-monitoring-logging',
        text_en: 'Is security information and event management (SIEM) deployed?',
        text_es: '¿La gestión de información y eventos de seguridad (SIEM) está desplegada?',
        text_ru: 'Развернута ли система управления событиями и информацией безопасности (SIEM)?',
        weight: 5,
      },
      {
        id: 'NIS2_ML_06',
        blockId: 'nis2-monitoring-logging',
        text_en: 'Are security events monitored 24/7?',
        text_es: '¿Los eventos de seguridad se monitorean 24/7?',
        text_ru: 'Отслеживаются ли события безопасности 24/7?',
        weight: 4,
      },
      {
        id: 'NIS2_ML_07',
        blockId: 'nis2-monitoring-logging',
        text_en: 'Are alerts configured for critical security events?',
        text_es: '¿Las alertas están configuradas para eventos críticos de seguridad?',
        text_ru: 'Настроены ли оповещения для критических событий безопасности?',
        weight: 4,
      },
      {
        id: 'NIS2_ML_08',
        blockId: 'nis2-monitoring-logging',
        text_en: 'Are logs regularly reviewed and analyzed?',
        text_es: '¿Los registros se revisan y analizan regularmente?',
        text_ru: 'Регулярно ли просматриваются и анализируются логи?',
        weight: 3,
      },
      {
        id: 'NIS2_ML_09',
        blockId: 'nis2-monitoring-logging',
        text_en: 'Is log access restricted and audited?',
        text_es: '¿El acceso a los registros está restringido y auditado?',
        text_ru: 'Ограничен и аудируется ли доступ к логам?',
        weight: 3,
      },
      {
        id: 'NIS2_ML_10',
        blockId: 'nis2-monitoring-logging',
        text_en: 'Are anomalous activities detected and investigated?',
        text_es: '¿Las actividades anómalas se detectan e investigan?',
        text_ru: 'Обнаруживаются и расследуются ли аномальные активности?',
        weight: 4,
      },
      {
        id: 'NIS2_ML_11',
        blockId: 'nis2-monitoring-logging',
        text_en: 'Is monitoring coverage comprehensive across the infrastructure?',
        text_es: '¿La cobertura de monitoreo es integral en toda la infraestructura?',
        text_ru: 'Является ли охват мониторинга комплексным по всей инфраструктуре?',
        weight: 4,
      },
    ],
  },
  // Category 10: Cryptography & Encryption (10 questions)
  {
    id: 'nis2-cryptography-encryption',
    name_en: 'Cryptography & Encryption',
    name_es: 'Criptografía y Cifrado',
    name_ru: 'Криптография и шифрование',
    questions: [
      {
        id: 'NIS2_CE_01',
        blockId: 'nis2-cryptography-encryption',
        text_en: 'Is encryption policy documented and enforced?',
        text_es: '¿La política de cifrado está documentada y aplicada?',
        text_ru: 'Документирована и применяется ли политика шифрования?',
        weight: 5,
      },
      {
        id: 'NIS2_CE_02',
        blockId: 'nis2-cryptography-encryption',
        text_en: 'Is data encrypted at rest for sensitive information?',
        text_es: '¿Los datos están cifrados en reposo para información sensible?',
        text_ru: 'Шифруются ли данные при хранении для чувствительной информации?',
        weight: 5,
      },
      {
        id: 'NIS2_CE_03',
        blockId: 'nis2-cryptography-encryption',
        text_en: 'Is data encrypted in transit?',
        text_es: '¿Los datos están cifrados en tránsito?',
        text_ru: 'Шифруются ли данные при передаче?',
        weight: 5,
      },
      {
        id: 'NIS2_CE_04',
        blockId: 'nis2-cryptography-encryption',
        text_en: 'Are cryptographic keys managed securely?',
        text_es: '¿Las claves criptográficas se gestionan de forma segura?',
        text_ru: 'Управляются ли криптографические ключи безопасно?',
        weight: 5,
      },
      {
        id: 'NIS2_CE_05',
        blockId: 'nis2-cryptography-encryption',
        text_en: 'Are strong encryption algorithms and protocols used?',
        text_es: '¿Se utilizan algoritmos y protocolos de cifrado fuertes?',
        text_ru: 'Используются ли стойкие алгоритмы и протоколы шифрования?',
        weight: 4,
      },
      {
        id: 'NIS2_CE_06',
        blockId: 'nis2-cryptography-encryption',
        text_en: 'Is key rotation performed regularly?',
        text_es: '¿La rotación de claves se realiza regularmente?',
        text_ru: 'Выполняется ли регулярная ротация ключей?',
        weight: 4,
      },
      {
        id: 'NIS2_CE_07',
        blockId: 'nis2-cryptography-encryption',
        text_en: 'Are digital signatures used where appropriate?',
        text_es: '¿Las firmas digitales se utilizan donde sea apropiado?',
        text_ru: 'Используются ли цифровые подписи где это уместно?',
        weight: 3,
      },
      {
        id: 'NIS2_CE_08',
        blockId: 'nis2-cryptography-encryption',
        text_en: 'Is certificate management implemented?',
        text_es: '¿La gestión de certificados está implementada?',
        text_ru: 'Реализовано ли управление сертификатами?',
        weight: 3,
      },
      {
        id: 'NIS2_CE_09',
        blockId: 'nis2-cryptography-encryption',
        text_en: 'Are deprecated cryptographic methods replaced?',
        text_es: '¿Los métodos criptográficos obsoletos se reemplazan?',
        text_ru: 'Заменяются ли устаревшие криптографические методы?',
        weight: 4,
      },
      {
        id: 'NIS2_CE_10',
        blockId: 'nis2-cryptography-encryption',
        text_en: 'Is encryption performance monitored and optimized?',
        text_es: '¿El rendimiento del cifrado se monitorea y optimiza?',
        text_ru: 'Отслеживается и оптимизируется ли производительность шифрования?',
        weight: 2,
      },
    ],
  },
  // Category 11: Asset Management (11 questions)
  {
    id: 'nis2-asset-management',
    name_en: 'Asset Management',
    name_es: 'Gestión de Activos',
    name_ru: 'Управление активами',
    questions: [
      {
        id: 'NIS2_AM_01',
        blockId: 'nis2-asset-management',
        text_en: 'Is a complete asset inventory maintained?',
        text_es: '¿Se mantiene un inventario completo de activos?',
        text_ru: 'Ведется ли полный реестр активов?',
        weight: 5,
      },
      {
        id: 'NIS2_AM_02',
        blockId: 'nis2-asset-management',
        text_en: 'Are assets classified by criticality and sensitivity?',
        text_es: '¿Los activos se clasifican por criticidad y sensibilidad?',
        text_ru: 'Классифицируются ли активы по критичности и чувствительности?',
        weight: 5,
      },
      {
        id: 'NIS2_AM_03',
        blockId: 'nis2-asset-management',
        text_en: 'Are asset owners assigned and responsible?',
        text_es: '¿Los propietarios de activos están asignados y son responsables?',
        text_ru: 'Назначены ли владельцы активов и несут ли они ответственность?',
        weight: 4,
      },
      {
        id: 'NIS2_AM_04',
        blockId: 'nis2-asset-management',
        text_en: 'Is the asset lifecycle managed (acquisition to disposal)?',
        text_es: '¿El ciclo de vida de los activos se gestiona (adquisición a eliminación)?',
        text_ru: 'Управляется ли жизненный цикл активов (от приобретения до утилизации)?',
        weight: 4,
      },
      {
        id: 'NIS2_AM_05',
        blockId: 'nis2-asset-management',
        text_en: 'Are unauthorized assets detected and managed?',
        text_es: '¿Los activos no autorizados se detectan y gestionan?',
        text_ru: 'Обнаруживаются и управляются ли несанкционированные активы?',
        weight: 4,
      },
      {
        id: 'NIS2_AM_06',
        blockId: 'nis2-asset-management',
        text_en: 'Is asset inventory updated regularly?',
        text_es: '¿El inventario de activos se actualiza regularmente?',
        text_ru: 'Регулярно ли обновляется реестр активов?',
        weight: 3,
      },
      {
        id: 'NIS2_AM_07',
        blockId: 'nis2-asset-management',
        text_en: 'Are critical assets protected with enhanced security measures?',
        text_es: '¿Los activos críticos están protegidos con medidas de seguridad mejoradas?',
        text_ru: 'Защищены ли критичные активы усиленными мерами безопасности?',
        weight: 5,
      },
      {
        id: 'NIS2_AM_08',
        blockId: 'nis2-asset-management',
        text_en: 'Is asset disposal conducted securely?',
        text_es: '¿La eliminación de activos se realiza de forma segura?',
        text_ru: 'Осуществляется ли безопасная утилизация активов?',
        weight: 4,
      },
      {
        id: 'NIS2_AM_09',
        blockId: 'nis2-asset-management',
        text_en: 'Are asset dependencies and relationships documented?',
        text_es: '¿Las dependencias y relaciones de activos están documentadas?',
        text_ru: 'Документированы ли зависимости и связи активов?',
        weight: 3,
      },
      {
        id: 'NIS2_AM_10',
        blockId: 'nis2-asset-management',
        text_en: 'Is software asset management implemented?',
        text_es: '¿La gestión de activos de software está implementada?',
        text_ru: 'Реализовано ли управление программными активами?',
        weight: 3,
      },
      {
        id: 'NIS2_AM_11',
        blockId: 'nis2-asset-management',
        text_en: 'Are asset security requirements defined and enforced?',
        text_es: '¿Los requisitos de seguridad de activos están definidos y aplicados?',
        text_ru: 'Определены и применяются ли требования безопасности активов?',
        weight: 4,
      },
    ],
  },
  // Category 12: Human Resources Security (12 questions)
  {
    id: 'nis2-hr-security',
    name_en: 'Human Resources Security',
    name_es: 'Seguridad de Recursos Humanos',
    name_ru: 'Безопасность человеческих ресурсов',
    questions: [
      {
        id: 'NIS2_HRS_01',
        blockId: 'nis2-hr-security',
        text_en: 'Are background checks performed for employees?',
        text_es: '¿Se realizan verificaciones de antecedentes para empleados?',
        text_ru: 'Проводятся ли проверки биографических данных для сотрудников?',
        weight: 4,
      },
      {
        id: 'NIS2_HRS_02',
        blockId: 'nis2-hr-security',
        text_en: 'Are security awareness training programs conducted?',
        text_es: '¿Se realizan programas de capacitación en concienciación sobre seguridad?',
        text_ru: 'Проводятся ли программы обучения по осведомленности о безопасности?',
        weight: 4,
      },
      {
        id: 'NIS2_HRS_03',
        blockId: 'nis2-hr-security',
        text_en: 'Are employees trained on cybersecurity policies?',
        text_es: '¿Los empleados están capacitados en políticas de ciberseguridad?',
        text_ru: 'Обучены ли сотрудники политикам кибербезопасности?',
        weight: 4,
      },
      {
        id: 'NIS2_HRS_04',
        blockId: 'nis2-hr-security',
        text_en: 'Are security responsibilities included in job descriptions?',
        text_es: '¿Las responsabilidades de seguridad se incluyen en las descripciones de trabajo?',
        text_ru: 'Включены ли обязанности по безопасности в должностные инструкции?',
        weight: 3,
      },
      {
        id: 'NIS2_HRS_05',
        blockId: 'nis2-hr-security',
        text_en: 'Is employee access reviewed upon role changes?',
        text_es: '¿El acceso de empleados se revisa cuando cambian de rol?',
        text_ru: 'Пересматривается ли доступ сотрудников при изменении ролей?',
        weight: 4,
      },
      {
        id: 'NIS2_HRS_06',
        blockId: 'nis2-hr-security',
        text_en: 'Are contractors and third parties subject to security screening?',
        text_es: '¿Los contratistas y terceros están sujetos a verificación de seguridad?',
        text_ru: 'Подвергаются ли подрядчики и третьи стороны проверке безопасности?',
        weight: 4,
      },
      {
        id: 'NIS2_HRS_07',
        blockId: 'nis2-hr-security',
        text_en: 'Are confidentiality agreements signed by employees?',
        text_es: '¿Los acuerdos de confidencialidad están firmados por empleados?',
        text_ru: 'Подписаны ли соглашения о конфиденциальности сотрудниками?',
        weight: 3,
      },
      {
        id: 'NIS2_HRS_08',
        blockId: 'nis2-hr-security',
        text_en: 'Is there a disciplinary process for security violations?',
        text_es: '¿Existe un proceso disciplinario para violaciones de seguridad?',
        text_ru: 'Существует ли дисциплинарный процесс за нарушения безопасности?',
        weight: 3,
      },
      {
        id: 'NIS2_HRS_09',
        blockId: 'nis2-hr-security',
        text_en: 'Are security training records maintained?',
        text_es: '¿Los registros de capacitación en seguridad se mantienen?',
        text_ru: 'Ведется ли учет обучения по безопасности?',
        weight: 3,
      },
      {
        id: 'NIS2_HRS_10',
        blockId: 'nis2-hr-security',
        text_en: 'Is there a process for reporting security concerns?',
        text_es: '¿Existe un proceso para reportar preocupaciones de seguridad?',
        text_ru: 'Существует ли процесс сообщения о проблемах безопасности?',
        weight: 3,
      },
      {
        id: 'NIS2_HRS_11',
        blockId: 'nis2-hr-security',
        text_en: 'Are security awareness campaigns conducted regularly?',
        text_es: '¿Las campañas de concienciación sobre seguridad se realizan regularmente?',
        text_ru: 'Проводятся ли регулярно кампании по повышению осведомленности о безопасности?',
        weight: 2,
      },
      {
        id: 'NIS2_HRS_12',
        blockId: 'nis2-hr-security',
        text_en: 'Is security culture promoted within the organization?',
        text_es: '¿La cultura de seguridad se promueve dentro de la organización?',
        text_ru: 'Продвигается ли культура безопасности в организации?',
        weight: 3,
      },
    ],
  },
];



